export const Image_url = "https://simplychartful.com/media/";
export const Base_url = "https://simplychartful.com";
// export const Image_url = "http://localhost:8080/media/";
// export const Base_url = "http://localhost:8080";

export const Live_Feed_Id = "88b54f11-f531-49b7-b430-727e89fdfd61";
export const Stream_Chat_Id = "b6d27d19-c6d7-41c9-8555-33e55e802110";

export const ImagUrlFxn = (values) => {
  let result = values;
  if (values.includes("public")) {
    result = values.replace("public/media", "");
  }
  return result;
};
